import { useState, type FormEvent } from 'react';

import PasswordInput from '../Common/PasswordInput';
import useAuth from '../../hooks/useAuth';
import { ApiClientError } from '../../services/api';

type LoginProps = {
  onShowRegister: () => void;
  registrationAllowed: boolean;
};

const Login = ({ onShowRegister, registrationAllowed }: LoginProps) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();

  const handleLogin = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
    } catch (reason) {
      setError(
        reason instanceof ApiClientError
          ? reason.message
          : 'Inloggen is momenteel niet mogelijk.',
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="auth-card" aria-labelledby="login-title">
      <div className="brand-mark" aria-hidden="true">
        AI
      </div>
      <h1 id="login-title">Welkom bij AI MessageBot</h1>
      <p className="muted">Log veilig in op je berichtenassistent.</p>
      <form onSubmit={handleLogin} className="form-stack">
        <label>
          E-mailadres
          <input
            type="email"
            name="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={submitting}
            required
          />
        </label>
        <PasswordInput
          label="Wachtwoord"
          name="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={submitting}
          required
        />
        {error && (
          <p className="notice error" role="alert">
            {error}
          </p>
        )}
        <button type="submit" className="button primary" disabled={submitting}>
          {submitting ? 'Bezig met inloggen…' : 'Inloggen'}
        </button>
      </form>
      {registrationAllowed && (
        <button type="button" className="button link" onClick={onShowRegister}>
          Nieuw account aanmaken
        </button>
      )}
    </section>
  );
};

export default Login;